import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Uncategorized Service Stores
 * These stores don't have corresponding api-types directories yet
 * or don't fit into a specific module category.
 *
 * Note: These services should be categorized or removed once the backend
 * api-types are finalized. Many of these may belong to other modules.
 */
export const uncategorizedStores: ServiceStoreConfig[] = [
  {
    name: "plant-layout",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.plantLayoutStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalLayouts = entities.length;
          const activeLayout = entities.find(
            (layout: Record<string, unknown>) => layout.isActive === true
          ) as Record<string, unknown> | undefined;
          const zones = activeLayout?.zones ? (activeLayout.zones as unknown[]).length : 0;
          const layoutVersion = activeLayout?.version || 0;

          return [
            {
              title: "Total Layouts",
              value: () => totalLayouts.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active Version",
              value: () => `v${layoutVersion}`,
              valueColor: "success.main",
            },
            {
              title: "Total Zones",
              value: () => zones.toString(),
              valueColor: "info.main",
            },
            {
              title: "Layout Type",
              value: () => activeLayout?.layoutName ? "Configured" : "Not Set",
              valueColor: activeLayout?.layoutName ? "success.main" : "warning.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "dashboard-metrics",
    options: {
      enableStorage: false,
      enableErrorNotifications: true,
    },
  },
  {
    name: "data-import",
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true, // unavailable in this tenant — no initial find, and no toast if one is called
    },
  },
  {
    name: "api-tokens",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      disableInitialFind: true, // unavailable in this tenant — no initial find, and no toast if one is called
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.apiTokensStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalTokens = entities.length;
          const active = entities.filter(
            (token: Record<string, unknown>) => token.status === "active"
          ).length;
          const expired = entities.filter((token: Record<string, unknown>) => {
            if (!token.expiresAt) return false;
            const expiryDate = new Date(token.expiresAt as string);
            return expiryDate < new Date();
          }).length;
          const revoked = entities.filter(
            (token: Record<string, unknown>) => token.status === "revoked"
          ).length;

          return [
            {
              title: "Total Tokens",
              value: () => totalTokens.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => active.toString(),
              valueColor: "success.main",
            },
            {
              title: "Expired",
              value: () => expired.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Revoked",
              value: () => revoked.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
    },
  },
];
